'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nextUtil = require('../../next-util/lib/index.js');

var _section = require('./accordion/section.js');

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/** Accordion */
var Accordion = (_temp = _class = function (_React$Component) {
    _inherits(Accordion, _React$Component);

    function Accordion(props, context) {
        _classCallCheck(this, Accordion);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

        _this.trigger = _this.trigger.bind(_this);
        _this.useProp(_this.props, true);
        return _this;
    }

    Accordion.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        //只有传递数据模型时才接受改变
        this.useProp(nextProps);
    };

    Accordion.prototype.useProp = function useProp(props, initial) {
        var dataModel = Array.isArray(props.dataSource);
        // 数据归一化 无论是来自于props.dataSource 还是来自于props.children
        var data = dataModel ? props.dataSource : _react2['default'].Children.map(props.children, function (e) {
            return _extends({
                key: e.key
            }, e.props);
        });
        var state = initial ? { section: [] } : this.state; // 初始化的时候没办法过去 this.state 所以给予一个默认值

        var _getSectionsProp = this.getSectionsProp(data, state),
            section = _getSectionsProp.section,
            expandedWarning = _getSectionsProp.expandedWarning,
            multiTitleWarning = _getSectionsProp.multiTitleWarning;

        if (initial) {
            this.state = {
                section: section,
                dataModel: dataModel
            };
        } else {
            this.setState({
                section: section,
                dataModel: dataModel
            });
        }

        if (expandedWarning) {
            // expand -》 expanded。
            _nextUtil.log.deprecated('expand', 'expanded', 'Accordion');
        }
        if (multiTitleWarning) {
            // mutliTitle -》 multiTitle。
            _nextUtil.log.deprecated('mutliTitle', 'multiTitle', 'Accordion');
        }
    };

    Accordion.prototype.getSectionsProp = function getSectionsProp(data, state) {
        // 这个函数的逻辑比较复杂

        // 获取之前存下来的 section
        var sectionInState = state.section;
        // 把section 变成 key value的形式

        var keySection = sectionInState.reduce(function (prev, curr) {
            var key = curr.key;

            if (key !== undefined && key !== null) {
                prev[key] = curr;
            }
            return prev;
        }, {});

        // 如果每个Children都传入了key, 称之为 KeyMode 如果每个都没传key或者 只有部分Children有key 则非keyMode
        // 计算之前的keyMode
        var prevhasKeys = Object.keys(keySection).length > 0;
        var prevKeyMode = prevhasKeys && Object.keys(keySection).length === sectionInState.length;

        // 计算现在的keyMode
        var currentKeys = data.filter(function (element) {
            return element.key !== undefined && element.key !== null;
        });
        var currentKeyMode = data.length === currentKeys.length && currentKeys.length > 0;

        // 如果现在 只有部分Children有key 那么基于Warning
        var currentlackOfKey = data.length !== currentKeys.length && currentKeys.length > 0;
        if (currentlackOfKey) {
            // eslint-disable-next-line no-console
            console.error('Every Panel should have a key or None of Panel should have a key');
        }

        var expandedWarning = false;
        var multiTitleWarning = false;
        var sectionsProp = data.map(function (e, index) {
            var expanded = e.expanded,
                expand = e.expand,
                mutliTitle = e.mutliTitle,
                multiTitle = e.multiTitle,
                title = e.title,
                content = e.content,
                disabled = e.disabled,
                className = e.className,
                style = e.style,
                key = e.key,
                others = _objectWithoutProperties(e, ['expanded', 'expand', 'mutliTitle', 'multiTitle', 'title', 'content', 'disabled', 'className', 'style', 'key']);

            var _expanded = function () {
                // expand -》 expanded。
                var isExpanded = void 0;
                if (expand !== undefined) {
                    expandedWarning = true;
                }
                if (expanded !== undefined) {
                    isExpanded = !!expanded;
                } else if (expand !== undefined) {
                    isExpanded = !!expand;
                } else {
                    // 没有 expanded 和 expand也都没传入 说明用户完全不控制 Panel的展开状态

                    // 那么 处理这个Panel的时候 沿用原来的状态
                    // 如果之前传入的Children是keyMode  现在传入的Children也是keyMode 则按照key匹配模式复用状态
                    // 如果之前传入的Children非keyMode 现在传入的Children也非keyMode 则按照index匹配模式复用状态
                    // 如果之前传入的Children和现在传入的Children 一个keyMode 一个非keyMode 则认为全新的Panel 默认折叠
                    // eslint-disable-next-line no-lonely-if
                    if (prevKeyMode === currentKeyMode && currentKeyMode === true) {
                        // 如果之前传入的Children是keyMode  现在传入的Children也是keyMode 则按照key匹配模式复用状态
                        isExpanded = keySection[key] && keySection[key].expanded;
                    } else if (prevKeyMode === currentKeyMode && currentKeyMode === false) {
                        // 如果之前传入的Children非keyMode 现在传入的Children也非keyMode 则按照index匹配模式复用状态
                        isExpanded = sectionInState[index] && sectionInState[index].expanded;
                    } else {
                        isExpanded = false;
                    }
                }
                return isExpanded;
            }();

            var _multiTitle = function () {
                // mutliTitle -》 multiTitle。
                var isMultiTitle = void 0;
                if (mutliTitle !== undefined) {
                    multiTitleWarning = true;
                }
                if (multiTitle !== undefined) {
                    isMultiTitle = !!multiTitle;
                } else if (mutliTitle !== undefined) {
                    isMultiTitle = !!mutliTitle;
                } else {
                    isMultiTitle = !!multiTitle;
                }
                return isMultiTitle;
            }();

            return _extends({
                expanded: _expanded,
                title: title,
                children: content,
                disabled: !!disabled,
                multiTitle: _multiTitle,
                className: className,
                style: style,
                key: key
            }, others);
        });

        return { section: sectionsProp, expandedWarning: expandedWarning, multiTitleWarning: multiTitleWarning };
    };

    Accordion.prototype.singleCheck = function singleCheck(stateSection, index) {
        var _this2 = this;

        var section = stateSection.slice();

        if (this.props.single === true) {
            //固定单条显示
            section = section.map(function (suc, key) {
                var newSuc = function (o) {
                    //Object.assign不兼容ie9
                    for (var i in suc) {
                        if (!suc.hasOwnProperty(i)) {
                            continue;
                        }
                        o[i] = suc[i];
                    }
                    return o;
                }({});

                if (index === key) {
                    if (_this2.props.singleShrink === true) {
                        //设置这个属性单例子模式可收起全部
                        newSuc.expanded = !newSuc.expanded;
                    } else {
                        newSuc.expanded = true;
                    }
                } else {
                    newSuc.expanded = false;
                }
                return newSuc;
            });
        } else {
            //可以多条显示
            section = section.map(function (suc, key) {
                var newSuc = function (o) {
                    //Object.assign不兼容ie9
                    for (var i in suc) {
                        if (!suc.hasOwnProperty(i)) {
                            continue;
                        }
                        o[i] = suc[i];
                    }
                    return o;
                }({});
                if (index === key) {
                    newSuc.expanded = !newSuc.expanded;
                }
                return newSuc;
            });
        }

        return {
            section: section
        };
    };

    Accordion.prototype.trigger = function trigger(index) {
        var singleCheck = this.singleCheck(this.state.section, index);
        if (this.state.dataModel === false) {
            this.setState({
                section: singleCheck.section
            });
        }

        typeof this.props.onChange === 'function' && this.props.onChange(singleCheck.section.map(function (sec) {
            return sec.expanded;
        }), singleCheck.section);
    };

    Accordion.prototype.render = function render() {
        var _this3 = this;

        // 支持从context上获取prefix
        var prefix = this.context.prefix || this.props.prefix;

        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(prefix + 'accordion', this.props.className), style: this.props.style },
            this.state.section.map(function (e, keys) {
                var title = e.title,
                    disabled = e.disabled,
                    expanded = e.expanded,
                    multiTitle = e.multiTitle,
                    className = e.className,
                    style = e.style,
                    children = e.children,
                    key = e.key,
                    others = _objectWithoutProperties(e, ['title', 'disabled', 'expanded', 'multiTitle', 'className', 'style', 'children', 'key']);

                return _react2['default'].createElement(
                    _section2['default'],
                    _extends({
                        title: title,
                        disabled: !!disabled,
                        expanded: !!expanded,
                        trigger: _this3.trigger,
                        multiTitle: !!multiTitle,
                        key: keys,
                        index: keys,
                        className: className,
                        style: style,
                        prefix: prefix
                    }, others),
                    children
                );
            })
        );
    };

    return Accordion;
}(_react2['default'].Component), _class.propTypes = {
    /**
     * 样式前缀
     */
    prefix: _propTypes2['default'].string,
    /**
     * 组件接受行内样式
     */
    style: _propTypes2['default'].object,
    /**
     * 使用数据模型构建
     */
    dataSource: _propTypes2['default'].array,
    /**
     * 如果这个属性为true, 在single为true时, 组件可以收起全部子元素
     */
    singleShrink: _propTypes2['default'].bool,
    /**
     * 是否只能展开1个
     */
    single: _propTypes2['default'].bool,
    /**
     * 接收一个回调函数传递改变状态, 在使用dataSource时改回调需要产生改变组件才能生效
     */
    onChange: _propTypes2['default'].func,
    /**
     * 扩展class
     */
    className: _propTypes2['default'].string
}, _class.defaultProps = {
    single: false,
    prefix: 'next-'
}, _class.contextTypes = {
    prefix: _propTypes2['default'].string
}, _temp);
Accordion.displayName = 'Accordion';


Accordion.Panel = _react2['default'].Component;
exports['default'] = Accordion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-accordion/lib/index.js
// module id = 157
// module chunks = 0